import { CENSORED_APPLICANT_STATUSES } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetCensoredApplicant } from 'cpool-tables/backend-resolvers';
import { schemaLoanRequestResolver_GetCensoredApplicant } from 'cpool-tables/backend-resolvers';
import type { TFunction } from 'i18next';
import { toast } from 'react-toastify';

import { fetcher } from '~/queryUtils/useQuery';

export const verifyCensorCoApplicantStatus = async ({
    loanRequestId,
    t,
}: {
    loanRequestId: string;
    t: TFunction<'de' | 'en', undefined>;
}) => {
    try {
        const response: SchemaLoanRequestResolver_GetCensoredApplicant = await fetcher({
            meta: {
                queryUrl: `/query/loan-request/getCensoredApplicant?loanRequestId=${loanRequestId}`,
                schema: schemaLoanRequestResolver_GetCensoredApplicant,
            },
        });
        if (!response || response.status === CENSORED_APPLICANT_STATUSES.PENDING) {
            toast.info(t('STATUS.CENSOR_CO_APPLICANT_TOASTS.OPERATION_TIMEOUT'));
            return;
        }
        if (response.status === CENSORED_APPLICANT_STATUSES.SUCCEEDED) {
            toast.success(t('STATUS.CENSOR_CO_APPLICANT_TOASTS.OPERATION_SUCCESS'));
            return;
        }
        // failed
        const errorMessage = response.errors.length > 0 ? response.errors.join('\n') : undefined;
        toast.error(
            errorMessage
                ? `${t('STATUS.CENSOR_CO_APPLICANT_TOASTS.OPERATION_ERROR')}\n${errorMessage}`
                : t('STATUS.CENSOR_CO_APPLICANT_TOASTS.OPERATION_ERROR'),
        );
    } catch {
        toast.error(t('STATUS.CENSOR_CO_APPLICANT_TOASTS.OPERATION_ERROR'));
    }
};
